export const createBannerUrl = "/banners/addBanner";
export const allBannersUrl = "/banners/getAllBanners";
export const removeBannerUrl = "/banners/removeBanner/{position}";